import { render, staticRenderFns } from "./YoutubeAuth.vue?vue&type=template&id=5cb3f47e&scoped=true"
import script from "./YoutubeAuth.vue?vue&type=script&lang=js"
export * from "./YoutubeAuth.vue?vue&type=script&lang=js"
import style0 from "./YoutubeAuth.vue?vue&type=style&index=0&id=5cb3f47e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3f47e",
  null
  
)

export default component.exports